import * as stateManagement from '#packages/stateManagement';
import type {
  MapStateToProps,
  MapDispatchToProps,
  ThunkAction,
} from 'types/redux';
import type {
  SaveButtonDispatchProps,
  SaveButtonOwnProps,
  SaveButtonStateProps,
} from './save';
import type { SaveInteractionStartedSource } from 'types/fedops/saveInteraction';
import { fixedStage } from '#packages/util';
import experiment from 'experiment';
import * as util from '#packages/util';

const { getIsManualSave, getIsBuildInProgress } =
  stateManagement.savePublish.selectors;

export const mapStateToProps: MapStateToProps<
  SaveButtonStateProps,
  SaveButtonOwnProps
> = ({ editorAPI, state }) => {
  const disabled =
    editorAPI.savePublish.isPublishInProgress() ||
    editorAPI.savePublish.isSaveInProgress() ||
    getIsBuildInProgress(state);

  const isCustomTemplate =
    experiment.isOpen('se_customTemplateEditIndication') &&
    util.editorModel.isCustomTemplate;

  return {
    isFirstSave: editorAPI.dsRead?.generalInfo.isFirstSave(),
    isCustomTemplate,
    disabled,
    isManualSave: getIsManualSave(state),
    status: state.savingStatus,
    isZoomMode: editorAPI.zoomMode.isInZoomMode(),
    isSitePublished: editorAPI.dsRead?.generalInfo.isSitePublished(),
    topBarStateBIParamValue: fixedStage.getTopBarStateBiParamValue(editorAPI),
  };
};

export const mapDispatchToProps: MapDispatchToProps<
  SaveButtonDispatchProps,
  SaveButtonOwnProps
> = {
  save:
    (sourceOfStart: SaveInteractionStartedSource): ThunkAction =>
    (dispatch, getState, { editorAPI }) => {
      editorAPI.saveManager.save({ origin: 'topbar', sourceOfStart });
    },
};
